import { proxy } from 'valtio';
import isEmpty from 'lodash/isEmpty';
import storeRematch from '@/store';

/*
    Возможно, понадобится какое-то промежуточное состояние, поэтому - proxy.
*/

const findObjectById = (id, objects) => {
    for (const obj of objects) {
        if (obj.id === id) {
            return obj;
        }

        if (obj.children && Array.isArray(obj.children) && obj.children.length > 0) {
            const found = findObjectById(id, obj.children);
            if (found) {
                return found;
            }
        }
    }

    return null;
};

export const mer = proxy({
    getMerParams() {
        const {
            tree: { calculationObject, data: treeData },
            lists,
            baseFilterReport,
        } = storeRematch.getState();

        const { data, activeItemKey, activeGroupKey } = lists;
        const { date, period, isElements } = baseFilterReport.params;

        const fieldIdsRaw = new Set();
        const ventureIdsRaw = new Set();

        const addFieldAndVentureIds = item => {
            const parentField = item.parents.find(({ node }) => node === 'field')?.id;
            const parentVenture = item.parents.find(({ node }) => node === 'company')?.id; // venture front-end === company back-end
            fieldIdsRaw.add(parentField);
            ventureIdsRaw.add(parentVenture);
        };

        if (isEmpty(calculationObject)) {
            const activeItem = data.find(item => item.key === activeGroupKey || item.key === activeItemKey);

            if (activeItem?.children?.length) {
                // в случае выбранной группы
                activeItem.children.forEach(child => {
                    if (!child.parents) {
                        const item = findObjectById(child.id, treeData);

                        child.parents = item.parents;
                    }

                    addFieldAndVentureIds(child);
                });
            } else {
                // в случае выбранной скважины
                if (!activeItem.parents) {
                    const item = findObjectById(activeItem.id, treeData);

                    activeItem.parents = item.parents;
                }
                addFieldAndVentureIds(activeItem);
            }

            const fieldIds = [...fieldIdsRaw].join(',');
            const ventureId = [...ventureIdsRaw].join(','); // требования ReportBuilder'a, чтобы это называлось в единственном числе

            const params = { fieldIds, ventureId, date, period, objectId: fieldIds, isElements: isElements ?? false };

            return params;
        } else {
            if (calculationObject.nodeType === 'field') {
                const fieldIds = String(calculationObject.id);
                const ventureId = String(calculationObject.parents.find(p => p.node === 'organization')?.id);

                const params = {
                    fieldIds,
                    ventureId,
                    date,
                    period,
                    objectId: fieldIds,
                    isElements: isElements ?? false,
                };

                return params;
            } else if (calculationObject.nodeType === 'company') {
                const ventureId = String(calculationObject.id);

                const params = {
                    ventureId,
                    date,
                    period,
                    isElements: isElements ?? false,
                };

                return params;
            } else if (calculationObject.nodeType === 'organization') {
                const ventureIdRaw = calculationObject.children.map(c => c.id).flat();
                const ventureIdSet = new Set(ventureIdRaw);
                const params = {
                    ventureId: [...ventureIdSet].join(''),
                    date,
                    period,
                    isElements: isElements ?? false,
                };

                return params;
            }
        }
    },
});
